// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3MtI-","actions":"GroupTable_actions__2T5oJ","deleteModalFooter":"GroupTable_deleteModalFooter__2xwxV"};